module.exports = __webpack_public_path__ + "static/media/help-icon.b0417fdc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/help-icon.svg
// module id = 798
// module chunks = 0